import React from "react";

export default function ErrorMessage({ error }) {
  return (
    <div className="error-message">
      <p>{error}</p>
    </div>
  );
}
